var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-rsi-view"},[_c('StockRSI')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }